import { defineComponent as o, createBlock as l, openBlock as n, unref as r, mergeProps as p, withCtx as m, createElementVNode as i } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const u = /* @__PURE__ */ o({
  name: "IconSwapFilled",
  __name: "IconSwapFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const t = a;
    return (s, e) => (n(), l(r(c), p(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        i("path", { d: "M16.293 3.293a1 1 0 0 1 1.414 0l2.646 2.646a1.5 1.5 0 0 1 0 2.122l-2.646 2.646a1 1 0 0 1-1.414-1.414L17.586 8H13a1 1 0 1 1 0-2h4.586l-1.293-1.293a1 1 0 0 1 0-1.414M7 3.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5m7.5 10a1.25 1.25 0 0 0-1.25 1.25v5a1.25 1.25 0 0 0 1.25 1.25h5a1.25 1.25 0 0 0 1.25-1.25v-5a1.25 1.25 0 0 0-1.25-1.25h-5M6.414 18l1.293 1.293a1 1 0 1 1-1.414 1.414l-2.647-2.646a1.5 1.5 0 0 1 0-2.122l2.647-2.646a1 1 0 1 1 1.414 1.414L6.414 16H11a1 1 0 1 1 0 2H6.414" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
